module.exports = __webpack_public_path__ + "static/media/cl.11f7f79f.svg";